var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body",class:{ 'page-menu-closed': _vm.menuCollapsed },attrs:{"id":"app"}},[_c('router-view',{attrs:{"appMenuCollapsed":_vm.menuCollapsed},on:{"menu-toggled":_vm.onToggled}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b17f2abc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Content/src/App.vue
// module id = 558
// module chunks = 1